import type { VideoNode, VideoReference } from '@/api/types';

const COLS = 4;
const STEP_X = 340;
const STEP_Y = 240;

/**
 * Видео каталога → узел полотна 300×200 для mock-режима; постер из extra/media, трим
 * только у своего файла (CNV-11). В live ту же сетку строит сервер (canvas-spec.md §3.1).
 */
export function videoNodeFromVideo(
  canvasId: number,
  video: VideoReference,
  index: number,
  baseY: number,
  now: string = new Date().toISOString(),
): VideoNode {
  return {
    id: `v${video.id}`,
    canvas_id: canvasId,
    type: 'video',
    x: 120 + (index % COLS) * STEP_X,
    y: baseY + Math.floor(index / COLS) * STEP_Y,
    width: 300,
    height: 200,
    rotation: 0,
    z_index: 0,
    author_id: null,
    created_at: now,
    updated_at: now,
    video_reference_id: video.id,
    source_url: video.source_url,
    poster_url: video.extra?.thumbnail_url ?? video.media?.poster_url ?? null,
    in_sec: 0,
    out_sec: Math.min(5, video.duration_sec ?? 5),
    loop: true,
    muted: true,
    embed_only: !video.media,
  };
}
